export const TIPO_COPIA_DOCUMENTO = {
  NAO_SE_APLICA: 0,
  COPIA_CONTROLADA: 1,
  COPIA_NAO_CONTROLADA: 2,
};

export const TIPO_MARCA_DAGUA = {
  TEXTO: 1,
};

export const POSICAO_MARCA_DAGUA = {
  SUPERIOR_CENTRO: 1,
  CENTRO_ESQUERDA: 2,
  CENTRO: 3,
  CENTRO_DIREITA: 4,
  INFERIOR_CENTRO: 5,
};

export const COPIA_CONTROLADA_FIELDS = {
  TIPO_COPIA_DOCUMENTO_ID: 'tipoCopiaDocumentoId',
  QUANTIDADE_PERMITIDA_COPIAS: 'quantidadePermitidaCopias',
  TIPO_MARCA_DAGUA_ID: 'tipoMarcaDaguaId',
  POSICAO_MARCA_DAGUA_ID: 'posicaoMarcaDaguaId',
  TEXTO_MARCA_DAGUA: 'textoMarcaDagua',
  ARQUIVO_MARCA_DAGUA: 'arquivoMarcaDagua',
};

export const tipoCopiaDocumentoOptions = [
  {
    id: TIPO_COPIA_DOCUMENTO.NAO_SE_APLICA,
    label: 'labelNaoSeAplica',
  },
  {
    id: TIPO_COPIA_DOCUMENTO.COPIA_CONTROLADA,
    label: 'labelCopiaControlada',
  },
  {
    id: TIPO_COPIA_DOCUMENTO.COPIA_NAO_CONTROLADA,
    label: 'labelCopiaNaoControlada',
  },
];

export const tipoCopiaDocumentoHints = [
  {
    id: TIPO_COPIA_DOCUMENTO.COPIA_CONTROLADA,
    label: 'toolTipCopiaControlada',
  },
  {
    id: TIPO_COPIA_DOCUMENTO.COPIA_NAO_CONTROLADA,
    label: 'tooltipCopiaNaoControlada',
  },
];

export const posicoesMarcaDagua = [
  {
    id: POSICAO_MARCA_DAGUA.SUPERIOR_CENTRO,
    gridColumn: 2,
    gridRow: 1,
    buttonWidth: 65,
    buttonHeight: 13,
  },
  {
    id: POSICAO_MARCA_DAGUA.CENTRO_ESQUERDA,
    gridColumn: 1,
    gridRow: 2,
    buttonWidth: 13,
    buttonHeight: 65,
  },
  {
    id: POSICAO_MARCA_DAGUA.CENTRO,
    gridColumn: 2,
    gridRow: 2,
    buttonWidth: 65,
    buttonHeight: 13,
  },
  {
    id: POSICAO_MARCA_DAGUA.CENTRO_DIREITA,
    gridColumn: 3,
    gridRow: 2,
    buttonWidth: 13,
    buttonHeight: 65,
  },
  {
    id: POSICAO_MARCA_DAGUA.INFERIOR_CENTRO,
    gridColumn: 2,
    gridRow: 3,
    buttonWidth: 65,
    buttonHeight: 13,
  },
];
